export const AREA_FILTERS = ["any", "under40", "40to60", "over60"] as const;
export type AreaFilter = (typeof AREA_FILTERS)[number];

/** Area filter of the chessboard (docs/design/Apartments.dc.html) */
export const matchesArea = (area: number | null, filter: AreaFilter) => {
  if (filter === "any") return true;
  if (area == null) return false;
  if (filter === "under40") return area < 40;
  if (filter === "40to60") return area >= 40 && area < 60;
  return area >= 60;
};

/** "1 150,5" or "1150.5" → 1150.5; empty → null; garbage → undefined */
export const parsePrice = (value: string): number | null | undefined => {
  const text = value.replace(/\s/g, "").replace(",", ".");
  if (!text) return null;
  const number = Number(text);
  return Number.isFinite(number) && number >= 0 ? number : undefined;
};
